import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * Entity reference for feedback
 */
export interface FeedbackEntity {
  id: string;
  type: string; // 'lesson_plan', 'feature', etc.
}

/**
 * Request to create feedback
 */
export interface CreateFeedbackRequest {
  feedbackType: string;
  feedbackText: string;
  entities?: FeedbackEntity[];
}

/**
 * Response from creating feedback
 */
export interface CreateFeedbackResponse {
  success: boolean;
  feedbackId: string;
}

@Injectable({ providedIn: 'root' })
export class FeedbackApiService {
  private readonly http = inject(HttpClient);

  /**
   * Submit feedback with optional entity references
   */
  submitFeedback(request: CreateFeedbackRequest): Observable<CreateFeedbackResponse> {
    return this.http.post<CreateFeedbackResponse>(
      `${environment.apiUrl}/feedback`,
      request
    );
  }
}
